import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 28.1 14.8",
  "content": "<symbol viewBox=\"0 0 28.1 14.8\" id=\"arrow\">\n\t<rect x=\"0\" y=\"6.4\" width=\"26.7\" height=\"2\" />\n\t<polygon points=\"21.7,14.8 20.1,13.5 25.4,7.4 20.1,1.3 21.7,0 28.1,7.4 \t\t\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/voice/sprite/arrow.svg
// module id = XGto
// module chunks = 0